export const EDIT_PROVIDER_PROFILE_DETAILS = {
    FIRST_NAME: "patientFirstName",
    LAST_NAME: "patientLastName",
    EMAIL: "patientEmail",
    CONTACT_NUMBER: "patientNumber",
    BSA_ID: "patientBSAId",
    BASE_CAMP: "baseCamp",
    GENDER: "gender",
    ROLE: "role",
    PROVIDER_TYPE: "providerType",
    YEAR_OF_EXPERIENCE: "yearOfExp",
    SPECIALITY: "speciality",
    FACILITY_NAME: "facilityName",
    STATUS: "status",
    DEPARTMENT: "department",
  };

  export const TYPE_OF_GENDER = [
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" },
    { label: "Other", value: "Other" }
  ];
    

  export const TYPE_OF_STATUS = [
    { label: "Active", value: "Active" },
    { label: "In Active", value: "InActive" },
  ];